import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  initializeAuth,
  OAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import { idToken as _idToken, user as _user } from 'rxfire/auth';
import {
  type Observable,
  BehaviorSubject,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { HttpError } from '../utils/rxjs.http';
import { app } from './config';

const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

if (import.meta.env.DEV) {
  connectAuthEmulator(auth, 'http://127.0.0.1:4792', { disableWarnings: true });
}

export const idToken = _idToken(auth);
export const user = _user(auth);
export const sessionExpired$ = new BehaviorSubject(false);

export const withIdToken = <T>(fn: (token: string) => Observable<T>) =>
  idToken.pipe(
    take(1),
    switchMap((token) => {
      if (token == null) {
        return throwError(() => new Error('Missing token'));
      }
      return fn(token);
    }),
    tap({
      next: () => {
        if (sessionExpired$.value) {
          sessionExpired$.next(false);
        }
      },
      error: (err: unknown) => {
        if (
          err instanceof HttpError &&
          err.response.status === 401 &&
          !sessionExpired$.value
        ) {
          sessionExpired$.next(true);
        }
      },
    })
  );

export const loginWithMicrosoft = () => {
  const provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({
    tenant: 'nrk.onmicrosoft.com',
  });
  return signInWithPopup(auth, provider);
};

export const logout = () => auth.signOut();
